export enum Gender {
  None,
  Female,
  Male
}

export const RoleLabelMap: { [key: string]: string } = {
  "admin": "Admin",
  "reconciliationsupervisor": "Reconciliation Supervisor",
  "reconciliationcoder": "Reconciliation Coder",
  "qcsupervisor": "QC Supervisor",
  "qccoder": "QC Coder"
};

export enum Roles {
  Admin = 1,
  ReconciliationSupervisor = 2,
  ReconciliationCoder = 3,
  QCSupervisor = 4,
  QCCoder = 5,
  VirtualCoder = 6,
  MLCoder = 7
}

export enum RolesNew {
  Admin = 1,
  "Reconciliation Supervisor" = 2,
  "Reconciliation Coder" = 3,
  "QC Supervisor" = 4,
  "QC Coder" = 5,
  VirtualCoder = 6,
  MLCoder = 7
}


export enum RoleTypes {
  Admin = 1,
  Supervisor = 2,
  Coder = 3
}

export enum TeamType {
  ML = 1,
  Coder = 2,
  OdpStaff = 3
}

export enum StageTypeEnum {
  NONE = 0,
  PREPARE = 1,
  INITIAL = 2,
  SECONDARY = 3
}


export enum SubmissionType {
  CoderEvaluation = 1,
  CoderConsensus = 2,
  OdpEvaluation = 3,
  OdpConsensus = 4,
  OdpWestatComparison = 5,
  CoderMlComparison = 6,
  MlEvaluation = 7
}

export enum WorkflowTaskTypes {
  LoadAbstracts = 1,
  LoadCodingData = 2,
  Individual = 3,
  Consensus = 4,
  Comparison = 5
}

export enum AbstractProtocolStatusEnum {
  READY = 1,
  INPROGRESS = 2,
  COMPLETED = 3
}


export enum AbstractStatus {
  UPLOADED_INTO_THE_SYSTEM_0 = 1,
  RETRIEVED_FOR_CODING_BY_CODER_1 = 2,
  READY_FOR_CONSENSUS_BY_CODERS_1A = 3,
  CONSENSUS_COMPLETED_BY_CODERS_1B = 4,
  MLCOMPARE_COMPLETED_BY_CODERS_1ML = 24,
  UNABLE_TO_CODE_BY_CODERS_1U = 5,
  CONSENSUS_COMPLETE_NOTES_UPLOADED_BY_CODERS_1N = 6,
  RETRIEVED_FOR_CODING_BY_ODP_STAFF_2 = 7,
  READY_FOR_CONSENSUS_BY_ODP_STAFF_2A = 8,
  CONSENSUS_COMPLETED_BY_ODP_STAFF_2B = 9,
  ODP_STAFF_AND_CODER_CONSENSUS_MERGED_2C = 10,
  UNABLE_TO_CODE_BY_ODP_STAFF_2U = 11,
  CONSENSUS_COMPLETE_NOTES_UPLOADED_BY_ODP_STAFF_2N = 12,
  CLOSED_3 = 13,
  DATA_EXPORTED_4 = 14,
  REOPEN_FOR_REVIEW_BY_ODP_STAFF_5 = 15,
  RETRIEVE_FOR_CODING_BY_CODER_A_10 = 16,
  CODED_BY_CODER_A_11 = 17,
  RETRIEVE_FOR_CODING_BY_CODER_B_12 = 18,
  CODED_BY_CODER_B_13 = 19,
  RETRIEVE_FOR_AB_CONSENSUS_14 = 20,
  AB_CONSENSUS_COMPLETE_15 = 21,
  RETRIEVE_FOR_ADJUDICATION_BY_CODER_C_24 = 22,
  ADJUDICATION_COMPLETE_25 = 23
}
export enum WorkflowTask {
  TEAM_CODE_WFID1 = 1,
  CODER_A_WFID2 = 2,
  CODER_B_WFID2 = 3,
  CODER_AB_CONSENSUS_WFID2 = 4,
  CODER_A_WFID3 = 5,
  CODER_B_WFID3 = 6,
  CODER_C_ADJUDICATION_WFID3 = 7
}
